<template>
  <div class="dashboard">
    <!-- New Sign-Ups Section -->
    <div class="metric-card">
      <i class="fas fa-user-plus icon"></i>
      <h2>Total Sign-Ups</h2>
      <p class="count">{{ metrics.newSignUps }}</p>
      <button class="action" @click="navTo('ListNewCustomers')">view >></button>
    </div>

    <!-- Wait-List Section -->
    <div class="metric-card">
      <i class="fas fa-hourglass-half icon"></i>
      <h2>Wait-List Customers</h2>
      <p class="count">{{ metrics.waitList }}</p>
      <button class="action" @click="navTo('ListWaitlist')">view >></button>
    </div>

    <!-- Approved Customers Section -->
    <div class="metric-card">
      <i class="fas fa-check-circle icon"></i>
      <h2>Approved Customers</h2>
      <p class="count">{{ metrics.approvedCustomers }}</p>
      <!-- <button class="action" @click="navTo('ListNewCustomers')">view >></button> -->
    </div>

    <!-- Credit Check Bypass List -->
    <div class="metric-card">
      <i class="fas fa-clipboard-check icon"></i>
      <h2>CreditCheck Whitelist</h2>
      <p class="count">{{ metrics.creditCheckWhitelist }}</p>
      <button class="action" @click="navTo('CreditCheckWhitelist')">
        view >>
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import CalculatorService from "@/services/calculator.js";

export default {
  name: "OnboardingMetrics",
  components: {},
  props: {
    dateRange: {
      type: Object,
      required: true
    }
  },
  watch: {
    dateRange: {
      handler: "init",
      immediate: true
    }
  },
  data() {
    return {
      metrics: {
        newSignUps: 0,
        waitList: 0,
        approvedCustomers: 0,
        creditCheckWhitelist: 0
      }
    };
  },
  computed: {
    ...mapGetters(["getUsers"])
  },
  methods: {
    async init() {
      try {
        const res = await CalculatorService.metrics({
          start_date: this.dateRange.start,
          end_date: this.dateRange.end
        });
        this.metrics = res;
      } catch (error) {}
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style scoped>
.dashboard {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  background: inherit;
  padding: 20px 0;
}

.metric-card {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}

.metric-card h2 {
  color: #333;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 2px;
  margin: 0;
}

.metric-card .count {
  font-size: 40px;
  font-weight: bold;
  color: #3b83b3;
  margin: 0;
}

.icon {
  font-size: 30px;
  color: #3b83b3;
  position: absolute;
  right: 20px;
}

.action {
  border: none;
  background: inherit;
  text-align: left;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboardingTracker/OnboardingMetrics.vue